import { Spinner } from '../../../../../../../shared/frontend/components/presentational/spinner';
import { RecentGuildRankingsTableFrontpage } from './recentGuildRankingsTableFrontpage';

export function RecentRaidRankingsContentFrontpage(props: any) {
  if (!props.rankedGuilds) {
    return <Spinner inline />;
  }

  const loadingSpinner = props.uiLoading ? <Spinner /> : null;
  return (
    <div>
      {loadingSpinner}
      <RecentGuildRankingsTableFrontpage
        embedMode={true}
        mode="raid"
        raid={props.raid}
        region={props.region}
        realm={props.realm}
        guilds={props.rankedGuilds}
        difficulty={props.difficulty}
        title={props.title}
        recent={props.recent}
      />
    </div>
  );
}
